import axios from 'axios';
import { FieldConfig } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3001/api');

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

export const sellerIntakeAPI = {
  // Create new intake
  createIntake: async (propertyAddress: string, ownerCount: number = 1) => {
    const response = await api.post('/intakes', {
      property_address: propertyAddress,
      owner_count: ownerCount,
    });
    return response.data;
  },

  // Get intake by access token
  getIntake: async (accessToken: string) => {
    const response = await api.get(`/intakes/${accessToken}`);
    return response.data;
  },

  // Update intake progress
  updateIntake: async (accessToken: string, data: {
    current_section?: number;
    completion_percentage?: number;
    status?: string;
  }) => {
    const response = await api.put(`/intakes/${accessToken}`, data);
    return response.data;
  },

  // Save section data
  saveSection: async (accessToken: string, section: string, data: any) => {
    const response = await api.post(`/intakes/${accessToken}/sections/${section}`, data);
    return response.data;
  },

  // Get all section data
  getAllData: async (accessToken: string) => {
    const response = await api.get(`/intakes/${accessToken}/data`);
    return response.data;
  },

  // Get required fields config (public, used at form load)
  getRequiredFields: async (): Promise<FieldConfig[]> => {
    const response = await api.get('/field-configs/required');
    return response.data;
  },
};

export const adminAPI = {
  // Get all intakes for admin
  getIntakes: async (filters?: {
    status?: string;
    limit?: number;
    offset?: number;
  }) => {
    const params = new URLSearchParams();
    if (filters?.status) params.append('status', filters.status);
    if (filters?.limit) params.append('limit', filters.limit.toString());
    if (filters?.offset) params.append('offset', filters.offset.toString());

    const response = await api.get(`/admin/intakes?${params}`);
    return response.data;
  },

  // Get all field configs grouped by section
  getFieldConfigs: async (): Promise<{ fields: FieldConfig[]; grouped: Record<string, FieldConfig[]> }> => {
    const response = await api.get('/admin/field-configs');
    return response.data;
  },

  // Toggle is_required for a single field
  updateFieldConfig: async (id: number, isRequired: boolean): Promise<void> => {
    await api.patch(`/admin/field-configs/${id}`, { is_required: isRequired });
  },

  deleteIntake: async (intakeId: string): Promise<void> => {
    const res = await fetch(`${API_BASE_URL}/admin/intakes/${intakeId}`, { method: 'DELETE' });
    if (!res.ok) throw new Error('Failed to delete intake');
  },
};

export default api;
